<template>
    <!--<div class='olap-scale_link' state="normal"></div>-->
  <div class='h100' ref='echartsPie'></div>
</template>

<script>
import echarts from 'echarts';
import Vue from 'vue';

Vue.prototype.$echarts = echarts;
export default {
  name: 'EchartsPie',
  props: [
    'element',
  ],
  data() {
    return {
      chart: null, // 图表
      title: this.element.title,
      unit: this.element.unit,
      legendData: this.element.legendData,
      seriesData: []
    };
  },
  created() {
    // this.loadEchart()
    // this.$nextTick(()=> {
    //   this.loadEchart()
    // })
  },
  mounted(){
    let $this = this;
    $this.loadEchart();
    window.addEventListener('resize', () => {
      $this.chart.resize();
    });
  },
  methods: {
    loadEchart() {
      console.log('seriesData', this.seriesData);
      this.chart = this.$echarts.init(this.$refs.echartsPie);
    },
    initChart(){
      let $this = this;
      $this.chart.setOption({
        // backgroundColor: '#2c343c',
        title: {
          text: $this.title,
          // subtext: '纯属虚构',
          // left: 'center',
          top: 1,
          left: 1,
          textStyle: {
            color: '#ccc'
          }
        },
        tooltip: {
          trigger: 'item',
          // formatter: '{a} <br/>{b} : {c} ({d}%)'
          formatter: function(params){ //避免文字太长做省略处理
            let name=params.name; //名字
            const percent=params.percent; //占比
            const value=params.value; //数量
            if(name.length>8){
              name = name.slice(0,7)+"...";
              return `${name} : ${value} ${$this.unit} (${percent}%)`;
            }else{
              return `${name} : ${value} ${$this.unit} (${percent}%)`;
            }
          }
        },
        legend: {
          // type : 'scroll',
          // orient : 'horizontal',
          left: 'center',
          top: 'bottom',
          // data: ['rose1', 'rose2', 'rose3', 'rose4', 'rose5', 'rose6', 'rose7', 'rose8']
          data: $this.legendData
        },
        toolbox: {
          show: true,
          feature: {
            mark: {show: true},
            dataView: {
              show: true,
              readOnly: true,
              optionToContent: function (opt) {
                let seriesData = opt.series[0].data; //坐标数据
                let tdHeads = ''; //表头
                let tdBodys = ''; //数据
                seriesData.forEach(item => {
                  //组装表头
                  tdHeads += `<td style="padding: 0 10px">${item.name}</td>`;
                  //组装表数据
                  tdBodys += `<td style="padding: 0 10px">${item.value}</td>`;
                });

                let table = `<table border="1" style="margin:auto;border-collapse:collapse;font-size:14px;text-align:center">
                                <tbody>
                                    <tr>${tdHeads}</tr>
                                    <tr>${tdBodys}</tr>
                                </tbody>
                              </table>`;
                return table;
              }
            },
            magicType: {
              show: true,
              type: ['pie', 'funnel']
            },
            restore: {show: false},
            saveAsImage: {show: true}
          }
        },
        series: [
          {
            name: '半径模式',
            type: 'pie',
            radius: ['20%', '70%'],
            center: ['50%', '45%'],
            roseType: 'radius',
            label: {
              show: true
            },
            data: $this.seriesData
            // label: {
            //   color: '#ccc'
            // },
            // labelLine: {
            //   lineStyle: {
            //     color: '#ccc'
            //   },
            //   smooth: 0.2,
            //   length: 10,
            //   length2: 20
            // },
            // itemStyle: {
            //   color: '#c23531',
            //   shadowBlur: 200,
            //   shadowColor: 'rgba(0, 0, 0, 0.5)'
            // },
            // data: [
            //   {value: 10, name: 'rose1'},
            //   {value: 5, name: 'rose2'},
            //   {value: 15, name: 'rose3'},
            //   {value: 25, name: 'rose4'},
            //   {value: 20, name: 'rose5'},
            //   {value: 35, name: 'rose6'},
            //   {value: 30, name: 'rose7'},
            //   {value: 40, name: 'rose8'}
            // ]
          },
        ]
      });
    },
    setDatas(params) {
      const seriesData = params.map((value,key) => {
        return {'value':value,'name':this.legendData[key]}
      });
      this.seriesData = seriesData;
      console.log('element.seriesData',this.seriesData)
      this.initChart();
    }
  }
};

</script>

<style scoped>

</style>
